
import React from 'react';
import { Button } from '@/components/ui/button';
import { Download, Trash2, FolderSymlink, Tag, CheckSquare } from 'lucide-react';
import { 
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger
} from '@/components/ui/dropdown-menu';

interface MediaBulkActionsProps {
  selectedCount?: number;
  onClearSelection?: () => void;
  onDeleteSelected?: () => void;
  onDownloadSelected?: () => void;
  onMoveSelected?: () => void;
  onTagSelected?: () => void;
}

const MediaBulkActions: React.FC<MediaBulkActionsProps> = ({ 
  selectedCount = 0,
  onClearSelection = () => {},
  onDeleteSelected = () => {},
  onDownloadSelected = () => {},
  onMoveSelected = () => {},
  onTagSelected = () => {}
}) => {
  return (
    <div className="flex items-center">
      <span className="text-sm mr-2">
        {selectedCount} {selectedCount === 1 ? 'item' : 'items'} selected
      </span>
      
      <Button 
        variant="ghost" 
        size="sm" 
        onClick={onClearSelection}
        className="mr-2"
      >
        Clear
      </Button>
      
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="default" size="sm">
            Actions
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          <DropdownMenuItem onClick={onDownloadSelected}>
            <Download className="mr-2 h-4 w-4" />
            Download
          </DropdownMenuItem>
          <DropdownMenuItem onClick={onMoveSelected}>
            <FolderSymlink className="mr-2 h-4 w-4" />
            Move to Folder
          </DropdownMenuItem>
          <DropdownMenuItem onClick={onTagSelected}>
            <Tag className="mr-2 h-4 w-4" />
            Add Tags
          </DropdownMenuItem>
          <DropdownMenuSeparator />
          <DropdownMenuItem 
            onClick={onDeleteSelected} 
            className="text-red-500 focus:text-red-500"
          >
            <Trash2 className="mr-2 h-4 w-4" />
            Delete
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
};

export default MediaBulkActions;
